import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProfileCheckComponent } from '../views/my-profile/profile-check/profile-check.component';

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<ProfileCheckComponent> {
  constructor(private dialog: MatDialog, private translateService: TranslateService) {}

  canDeactivate(component: ProfileCheckComponent): Observable<boolean> | boolean {
    if (!component.hasUnsavedChanges && !component.isSaving) {
      return true;
    }

    if (component.isSaving) {
      return component.saveNow().pipe(map(() => true));
    } else {
      return true;
    }
  }
}
